import icon1 from "../images/icon/quote-2.png";
import avt1 from "../images/layouts/team-10.jpg";
import avt2 from "../images/layouts/team-11.jpg";
import avt3 from "../images/layouts/team-13.jpg";

const dataTestimonials2 = [
  {
    id: 1,
    icon: icon1,
    text: "\"When You're Going To Change The World, Don't Ask For Permission\" 작은 아이디어와 시도들이 모여 세상을 변화시킬 수 있다고 생각합니다. 오늘 우리의 도전은 그 변화의 첫 걸음이 될것입니다.",
    avt: avt1,
    name: "Shin yeongbin",
    position: "CEO & AI Engineer",
  },
  {
    id: 2,
    icon: icon1,
    text: "나만이 줄 수 있는 선한 영향력을 주고 싶어하는, 사회라는 물결에 휩쓸리지 않고 나만의 물결을 만들어가고자 하는, 원활한 커뮤니케이션을 위해 타 분야에 대한 경험을 주저하지 않는",
    avt: avt2,
    name: "Shin sanghyun",
    position: "CTO & Frontend Developer",
  },
  {
    id: 3,
    icon: icon1,
    text: "\"Real generosity toward the future lies in giving all to the present.\" – Albert Camus, The Rebel, 1951",
    avt: avt3,
    name: "Kim minseung",
    position: "Backend Developer",
  },
];

export default dataTestimonials2;
